import type { PropsWithChildren } from 'react'
import { BsCheckLg as CheckIcon } from 'react-icons/bs'
import styled from 'styled-components'

import type { PostPreviewGridProps } from 'Components'
import {
  MediaIconWrap,
  IsPendingMarker,
  IsApprovedMarker,
  renderPostTypeIcon,
} from 'Components/PostPreviewGrid'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
  max-width: 295px;
  max-height: 387px;
  overflow-x: auto;
`

const GridItem = styled.div<{ $isPosted: boolean }>`
  position: relative;
  width: 95px; // fixed width to handle portrait size image
  aspect-ratio: 4 / 5; /* Using aspect-ratio property for 4:5 ratio */

  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  ${(props) =>
    props.$isPosted &&
    `
  opacity: 0.7;
  `}
`

export interface MobilePreviewGridProps {
  posts: PostPreviewGridProps['posts']
  isReadOnly: boolean
}

function MobilePreviewGrid({
  posts,
  isReadOnly,
}: PropsWithChildren<MobilePreviewGridProps>) {
  return (
    <div data-testid="mobile-preview-grid-container">
      <GridContainer>
        {posts.map((post) => (
          <GridItem key={post.id} $isPosted={post.status === 'posted'}>
            <img src={post.media.src} alt={post.media.type} />
            <MediaIconWrap>{renderPostTypeIcon(post.media.type)}</MediaIconWrap>
            {post.status === 'pending' && !isReadOnly && <IsPendingMarker />}
            {post.status === 'approved' && !isReadOnly && (
              <IsApprovedMarker>
                <CheckIcon />
              </IsApprovedMarker>
            )}
          </GridItem>
        ))}
      </GridContainer>
    </div>
  )
}

export default MobilePreviewGrid
